import React, { useState } from "react";
import Button from "./Button";
import "./Header.css";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img src="/assets-project/logotipo.png" alt="Pagarva" />
        </div>

        <button
          className="mobile-menu-toggle"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isMenuOpen ? "open" : ""}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
          <a href="#contact-section" className="nav-link">
            Contact
          </a>
          <Button
            variant="primary"
            href="/download/"
            trackingLabel="Download"
            trackingLocation="header"
          >
            Download
          </Button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
